import { render } from "./CienaLayout.vue?vue&type=template&id=04da071c&ts=true"
import script from "./CienaLayout.vue?vue&type=script&lang=ts"
export * from "./CienaLayout.vue?vue&type=script&lang=ts"

import "./CienaLayout.vue?vue&type=style&index=0&id=04da071c&lang=sass"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__